<template>

    <v-container fluid="" class="pa-0">
        <v-layout row class="pa-0">
          
            <v-text-field v-model="search" :disabled="disabled" :placeholder="label" clearable :hint="hint" :append-icon="append_icon" label="Adres">
                <template slot="append-outer" v-if="showDetailButton && !estate">
                    <v-icon v-if="!show_details" @click="show_details = true">mdi-chevron-down</v-icon>
                    <v-icon v-if="show_details" @click="show_details = false">mdi-chevron-up</v-icon>
                </template>
            </v-text-field>
        </v-layout>

        <v-list v-if="entries.length > 0" dense class="options">
          <template v-for="item in entries">
            <v-list-item @click="setValue(item)">
              <v-list-item-content>
                <v-list-item-title>{{item.weergavenaam}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-list>

        <div v-if="show_details">
            <v-layout row>
              <v-text-field  @input="change" v-model="user.organisation.details.address"      label="Straat + Huisnummer"></v-text-field>
            </v-layout>
            <v-layout row>
                <v-flex xs6>
                    <v-text-field class="pr-1"  @input="change" v-model="user.organisation.details.postal_code"  label="Postcode"></v-text-field>
                </v-flex>
                <v-flex xs6>
                    <v-text-field @input="change" v-model="user.organisation.details.city"         label="Plaats"></v-text-field>
                </v-flex>
            </v-layout>
        </div>
    </v-container >
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  props: {
    new: {
      type: Boolean,
      default: false
    },
    estate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    entries: [],
    isLoading: false,
    count: 0,
    search: "",
    model: null,
    show_details: false,
    adr_id: null,
    temp_label: ""
  }),

  methods: {
    ...mapActions(["change", "clearObject"]),
    setValue(item) {
      this.entries = [];
      this.search = "";

      this.$store.dispatch("change");

      if (this.new) {
        this.temp_label = "";

        if (this.estate) {
          this.$store.dispatch("setKadasterDetails", {
            id: item.id,
            new: true,
            estate: true
          });
        } else {
          this.$store.dispatch("setKadasterDetails", {
            id: item.id,
            new: true,
            estate: false,
            organisation: true
          });
        }
        this.temp_label = item.weergavenaam;
      } else if (!this.estate && !this.new) {
        this.$store.dispatch("setKadasterDetails", {
          id: item.id,
          vastgoed: false,
          new: false,
          organisation: true
        });
      }
    },
    getKadasterData(id, type) {
      this.$store.dispatch("createKadasterObject", {
        id: id,
        reference: type
      });
    }
  },
  computed: {
    ...mapState(["user", "app", "object", "temp_address"]),
    ...mapGetters(["addressObjectDescription"]),
    append_icon() {
      if (this.estate) {
        if (!this.new) {
          return "";
        }
      } else {
        return "mdi-magnify";
      }
    },
    disabled() {
      if (!this.new && this.estate) {
        this.show_details = true;
        return true;
      }
      return false;
    },
    showDetailButton() {
      if (this.new == false) {
        return true;
      } else {
        return false;
      }
    },
    label() {
      return this.$store.getters.addressObjectDescription(
        this.new,
        this.user,
        this.temp_address
      );
    },
    hint() {
      if (this.count == 0) {
        return "Start met typen om een adres te zoeken";
      } else if (this.count > 0) {
        return this.count + " adressen gevonden";
      }
    },
    query() {
      return (
        "https://geodata.nationaalgeoregister.nl/locatieserver/v3/suggest?q=" +
        this.search
      );
    }
  },
  watch: {
    query() {
      this.isLoading = true;

      fetch(this.query)
        .then(res => res.json())
        .then(res => {
          var docs = res.response.docs.filter(item => item.type == "adres");
          this.entries = docs;
          this.count = res.response.numFound;
        })
        .finally(() => (this.isLoading = false));
    }
  },
  mounted() {
    this.$store.state.temp_address = {};
  }
};
</script>

<style scoped>
.options {
  position: absolute;
  z-index: 1;
  width: calc(100% - 32px);
}
</style>


